import { Box, FlexProps, Grid } from "@chakra-ui/react"
import React, { forwardRef } from "react"

export const Card = forwardRef<HTMLDivElement, React.PropsWithChildren>(
  ({ children }, ref) => {
    return (
      <Box
        ref={ref}
        p={4}
        bg="ds.surface.raised.resting"
        shadow="ds.raised"
        borderRadius="16px"
        data-ui="layout-card"
      >
        {children}
      </Box>
    )
  }
)

type CardsProps = FlexProps & {
  columns?: number
}

export const Cards = forwardRef<HTMLDivElement, CardsProps>(
  ({ children, gap = 4, columns = 4, ...props }, ref) => {
    return (
      <Grid
        ref={ref}
        data-ui="layout-cards"
        gridTemplateColumns={`repeat(${columns}, 1fr)`}
        gap={gap}
        {...props}
      >
        {children}
      </Grid>
    )
  }
)
